<template>

  <div class="popup-box" @click.self="closeAction">
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="close" @click="closeAction">
        <path d="M23 0L11.999 11.001.999 0 0 1l10.999 11.001L0 23l.999 1 11-10.999L23 24l1-1-11.001-10.999L24 1z"/>
      </svg>

      <div class="popup-content">
          <div class="event-title" :style="{'backgroundImage': bgImage + ', url(static/img-placeholder.png)'}" @click="detectEventAction">
              <div class="inner">
                  <p class="subtitle">
                    <span>{{ relativeTime }}</span> // {{ getHoursMinutes(startTime) }} - {{ getHoursMinutes(endTime) }}
                  </p>
                  <p class="main-title">{{ currentEvent.title }}</p>
                  <ul class="meta">
                      <li v-if="currentEvent.year">{{ currentEvent.year }}</li>
                      <li v-if="eventDuration">{{ eventDuration }} min</li>
                      <li v-if="currentEvent.ageRating && currentEvent.ageRating > 0">
                          {{ $t('parental_guidance_rating') }}{{ currentEvent.ageRating }}
                      </li>
                  </ul>
              </div>
              <progress-bar v-if="eventType === 'live'"
                    :startTime="startTime"
                    :endTime="endTime"
                    :type="eventType"
              />
            <div v-if="eventType === 'live'" class="play-action">
              <img src="~assets/images/icons/play-2.png" class="play-gridview">
            </div>
          </div>

          <div class="popup-stripe">
              <div class="col col-grid-6">
                  <p class="col-subtitle">{{ $t('guide_nowtv_event_details_language') }}</p>
                  <p class="col-title">{{ currentEvent.language }}</p>
              </div>
              <div class="col col-grid-6">
                  <div class="logo-box">
                    <img :src="getChannelImagePath(selectedChannel.images, 'COLOR')" alt="" class="channel-img">
                  </div>
              </div>
          </div>
          <div class="popup-description">
            <div class="description-scroll optiscroll">
              <div class="inner">
                <p v-if="currentEvent.description">{{ currentEvent.description }}</p>
                <!-- Message for no description -->
                <p v-else class="message">{{ $t('general_noinformation_title') }}</p>
              </div>
            </div>
          </div>

      </div>
  </div>

</template>

<script>
import Optiscroll from 'optiscroll'
import ProgressBar from 'components/ProgressBar'
import { getThumbnailImagePath, getChannelImagePath } from 'helpers/images'
import DateTimeHelper from 'helpers/date'
import { mapState, mapMutations, mapActions } from 'vuex'
import { getEonUrl } from 'helpers/baseURLhelper'

export default {
  name: 'ModalDetail',
  components: {
    Optiscroll,
    ProgressBar
  },
  data: function () {
    return {
      processing: false
    }
  },
  props: {
    currentModal: String
  },
  computed: {
    ...mapState({
      currentEvent: state => state.guide.currentEvent,
      selectedChannel: state => state.guide.selectedChannel,
      nowTime: state => state.guide.nowTime
    }),
    relativeTime: function () {
      let time = DateTimeHelper.getRelative(this.currentEvent.startTime, {})
      if (time === 'Yesterday') {
        return this.$t('event_relativedate_yesterday')
      } else if (time === 'Today') {
        return this.$t('event_relativedate_today')
      } else if (time === 'Tomorrow') {
        return this.$t('event_relativedate_tomorrow')
      } else {
        return time
      }
    },
    bgImage: function () {
      return `url(${getThumbnailImagePath(this.currentEvent.images)})`
    },
    startTime: function () {
      return DateTimeHelper.toTimestamp(this.currentEvent.startTime)
    },
    endTime: function () {
      return DateTimeHelper.toTimestamp(this.currentEvent.endTime)
    },
    eventDuration: function () {
      return (this.endTime - this.startTime) / 60000
    },
    eventType () {
      return DateTimeHelper.getEventType(this.startTime, this.endTime, this.nowTime)
    }
  },
  methods: {
    ...mapMutations([
      'UPDATE_CURRENT_EVENT'
    ]),
    ...mapActions([
      'closeModal'
    ]),
    closeAction: function () {
      this.closeModal()
    },
    getChannelImagePath: function (images, mode) {
      return getChannelImagePath(images, mode)
    },
    getHoursMinutes: function (time) {
      return DateTimeHelper.getHoursMinutes(time)
    },
    detectEventAction: function (e) {
      if (e.target.classList.contains('play-gridview')) {
        window.open(`${getEonUrl()}/player/${this.currentEvent.channelId}`, '_blank')
      }
    }
  },
  mounted: function () {
    let scrollArea = this.$el.querySelector('.description-scroll')
    this.optiscrollInstance = new Optiscroll(scrollArea, {
      wrapContent: false
    })
  }
}
</script>

<style scoped lang="scss">
  @import 'uc/_variables';
  @import 'uc/_mixins';

  .popup-box {
    width: 856px;
    background: #fff;
    position: relative;
  }

  .close {
    width: 24px;
    height: 24px;
    position: absolute;
    top: 35px;
    right: 35px;
    cursor: pointer;
    fill: #fff;
    -webkit-filter: drop-shadow(1px 1px 1px rgba(0,0,0,0.75));
    filter: drop-shadow(1px 1px 1px rgba(0,0,0,0.75));
    z-index: 2;
  }

  .event-title {
    height: 400px;
    overflow: hidden;
    position: relative;
    background-position: top center;
    background-repeat: no-repeat;
    background-size: cover;
    background-color: #13417e;
      &:after {
        content: '';
        width: 100%;
        height: 160px;
        position: absolute;
        bottom: 0;
        left: 0;
        background: transparent;
        background: -webkit-gradient(left top,left bottom,color-stop(0,transparent),color-stop(100%,rgba(0,0,0,.7)));
        background: -webkit-linear-gradient(top,transparent,rgba(0,0,0,.7));
        background: linear-gradient(180deg,transparent,rgba(0,0,0,.7));
      }
      img {
        width: 100%;
        height: auto;
      }
      .inner {
        position: absolute;
        bottom: 0;
        left: 0;
        z-index: 1;
        padding: 35px 30px;
      }
      .main-title {
        font-size: 34px;
        font-weight: 300;
        letter-spacing: -0.1px;
        color: #fff;
        text-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
        margin-bottom: 5px;
      }
      .subtitle {
        font-size: 12px;
        color: #fff;
        margin-bottom: 0;
      }
    .subtitle span {
      text-transform: capitalize;
    }
      .meta li {
        display: inline-block;
        font-size: 12px;
        color: #fff;
      }
      .meta li:not(:last-child):after {
        content: '/';
        display: inline-block;
        margin: 0 5px;
      }
  }

  /deep/.event-actions li {
    width: 70px;
    height: 70px;
    margin: 0 16px;
  }

  .popup-stripe {
    background-color: #eee;
    padding: 20px 30px 20px 30px;
    @include cf;
      .col {
        padding: 0;
      }
      .col-subtitle {
        font-size: 12px;
        color: #8c8c8c;
        margin-bottom: 8px;
      }
      .col-title {
        font-size: 13px;
        color: #313e44;
        margin-bottom: 0;
      }
      .logo-box {
        float: right;
        width: 75px;
        height: 42px;
        display: flex;
        margin-right: 10px;
        justify-content: center;
        align-items: center;
          img {
            max-height: 70px;
            max-width: 140px;
          }
      }
  }
  body.ie .logo-box img {
    width: 100%;
  }

  .popup-description {
    // height: 100px;
    padding: 10px 0px 20px;
      .description-scroll {
        height: 90px;
      }
      .inner {
        padding: 0px 40px 0 30px;
      }
      p {
        font-size: 14px;
        font-weight: 300;
        line-height: 1.71;
        color: #323e43;
        margin: 0;
      }
  }

  .btns-section {
    padding: 0 40px;
      a {
        margin-bottom: 20px;
        border: solid 1px #a6c7f5;
      }

    &.disabled {
      opacity: 0.5;
    }
  }

  /deep/ .event-title .progress-wrap {
    position: absolute;
    top: auto;
    bottom: 0;
    left: 0;
    z-index: 1;
  }

  .play-action {
    position: absolute;
    top: 50%;
    margin-top: -36px;
    left: 0;
    right: 0;
    width: 72px;
    margin-left: auto;
    margin-right: auto;
    cursor: pointer;
    opacity: .8;
    transition: opacity .3s ease;
      &:hover {
        opacity: 1;
      }
  }

  @media only screen and (min-width: $breakpoint3) {
    .popup-box {
      width: 1200px;
    }
    .close {
      width: 30px;
      height: 30px;
      top: 35px;
      right: 35px;
    }
    .event-title {
      height: 560px;
    }
    .event-title .inner {
      padding-left: 60px;
      padding-bottom: 50px;
    }
    /deep/ .event-actions li {
      width: 100px;
      height: 100px;
      margin: 0 16px;
    }
    .event-title .main-title {
      font-size: 48px;
    }
    .event-title .subtitle,
    .event-title .meta li {
      font-size: 20px;
      margin-bottom: 2px;
    }
    .play-action {
      position: absolute;
      top: 50%;
      margin-top: -50px;
      left: 0;
      right: 0;
      width: 100px;
      height: 100px;
    }
    .popup-stripe {
      padding: 20px 40px 20px 60px;
    }
    .popup-stripe .col-subtitle {
      font-size: 16px;
    }
    .popup-stripe .col-title {
      font-size: 18px;
    }
    .popup-stripe .logo-box {
      width: 120px;
      height: 52px;
        img {
          max-width: 160px;
          max-height: 90px;
        }
    }
    .popup-description {
      padding-top: 20px;
      padding-bottom: 30px;
    }
    .popup-description .description-scroll {
      height: 160px;
    }
    .popup-description p {
      font-size: 20px;
      line-height: 40px;
    }
    .popup-description .inner {
      padding-left: 60px;
      padding-right: 80px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/modal/ModalDetail.vue